import { render } from "./PlantForm.vue?vue&type=template&id=501e31f1&ts=true"
import script from "./PlantForm.vue?vue&type=script&lang=ts"
export * from "./PlantForm.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src3687640787/src/biomass-frontend-pwc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__